export { DMS_MODULE } from '../constants';
export const CRUMB_LABEL_KEY = 'grdZakazka';
export const NAME = 'ZakazkaArchiv';
